import {
  mapDispatchSubmitApplication,
  mapStateToPropsNextButton
} from 'reg_redesign/redux/connectFunctions';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import ConsentAndDisclosures from 'components/component_lib/ConsentAndDisclosures';
import CtaButton from '@opploans/cta-button-component/CtaButton';

const page15 = {
  defaultNextPage: '',
  content: [
    configureProgressBar(95),
    configureTitle('Review the following disclosures.'),
    {
      component: ConsentAndDisclosures,
      props: {
        idsToValidate: ['elecCommDisclosure']
      }
    },
    {
      component: CtaButton,
      name: 'ContinueButton',
      dispatchOverride: mapDispatchSubmitApplication,
      props: {
        id: 'submitButton',
        additionalStyle: {
          fontSize: '1rem',
          height: '3.5rem',
          marginTop: '2.5rem',
          width: '100%'
        },
        children: 'Agree and Apply Now',
        className: 'next-btn',
        page: 'page-15'
      },
      stateToPropsOverride: mapStateToPropsNextButton
    }
  ]
};

export default page15;
